// package imports
import { useSession } from 'next-auth/react';
import { useTheme } from '@mui/material/styles';

// local imports
import { hasRealityCoachAccess } from 'services/subscriptionUtils';
import NewsLetterComponent from './NewsletterComponent';

interface RealityCoachAddOnRequiredFields {
  cTAText1: string;
  cTAText2: string;
  unsubscribeText: string;
  cTAlink: {
    href: string;
    target?: string;
    text: string;
  };
  cTALinkColor: string;
  backgroundColor: string;
  accentImage: string;
}

interface RealityCoachAddOnRequiredProps {
  module: {
    fields: RealityCoachAddOnRequiredFields;
  };
}

const RealityCoachAddOnRequired: React.FC<RealityCoachAddOnRequiredProps> = ({
  module: { fields },
}) => {
  const { data: session, status } = useSession();
  const theme = useTheme();

  return (
    <>
      {status === 'authenticated' && !hasRealityCoachAccess(session) && (
        <div
          className="fixed flex items-center justify-center inset-0 h-full bg-gradient-to-b from-transparent via-black/50 to-black"
          style={{ zIndex: theme.zIndex.drawer + 1 }}
        >
          <div className="w-full" id="newsletter-component">
            <NewsLetterComponent
              cTAText1={fields.cTAText1}
              cTAText2={fields.cTAText2}
              unsubscribeText={fields.unsubscribeText}
              cTAlink={fields.cTAlink}
              cTALinkColor={fields.cTALinkColor}
              backgroundColor={fields.backgroundColor}
              accentImage={fields.accentImage}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default RealityCoachAddOnRequired;
